<template>
  <SiteSection
    sectionId="section-job"
    sectionNo="4"
    label="職缺介紹"
    title="JOBS OFFERING"
  >
    <div class="slider-wrapper">
      <div class="sliders" :style="{ transform: `translateX(${positionX})` }">
        <template v-for="(job, index) in jobs">
          <Job
            :key="index"
            :isActive="isActive(index)"
            :disabled="isDisabled(index)"
            :imgNormal="job.imgNormal"
            :imgHover="job.imgHover"
            :position="job.position"
            @click.native="activate(index)"
            v-scroll-to="{
              el: '.jobs-detail-container',
              offset: -280,
            }"
          >
          </Job>
        </template>
      </div>
      <template v-if="showButton">
        <div
          class="button-prev"
          :class="{ 'button-disabled': prevBtnDisable }"
          slot="button-prev"
          @click="clickPrevBtn"
        ></div>
        <div
          class="button-next"
          slot="button-next"
          :class="{ 'button-disabled': nextBtnDisable }"
          @click="clickNextBtn"
        ></div>
      </template>
    </div>
    <div class="jobs-detail-container">
      <template v-for="(job, index) in jobs">
        <JobDetail
          v-show="isActive(index)"
          :key="index"
          :position="job.position"
          :cnPosition="job.cnPosition"
          :subtitle="job.subtitle"
          :intro="job.intro"
          :needs="job.needs"
        >
        </JobDetail>
      </template>
    </div>
  </SiteSection>
</template>

<script>
import SiteSection from "./source/Section.vue";
import Job from "./sectionJob/Job.vue";
import JobDetail from "./sectionJob/JobDetail.vue";

import {AVAILABLE_JOBS, JOBS_DATA} from "../models/Jobs.js";

export default {
    name: 'SectionJob',
    components: {
        SiteSection,
        Job,
        JobDetail
    },
    data: function() {
        const filteredJobsData = AVAILABLE_JOBS.map(position => 
            JOBS_DATA.find(job => job.position === position)
        );

        return {
            activeJob: 0,
            displayIndex: 0,
            displayNum: 6,
            slideWidth: 190,
            slidesOffsetBefore: 190,
            arrowOffset: 130,
            jobs: filteredJobsData,
        }
    },
    methods: {
        isActive: function(jobIndex) {
            if (jobIndex == this.activeJob) {
                return true;
            }
            return false;
        },
        activate: function(jobIndex) {
            this.activeJob = jobIndex;
        },
        getDisplayNum: function() {
            let winWidth = window.innerWidth;

            let displayNum = Math.floor(
                (winWidth - this.arrowOffset - this.slidesOffsetBefore) /
                this.slideWidth);

            this.displayNum = displayNum > 0 ? displayNum : 1;

            if (this.displayNum == 1) this.activeJob = this.displayIndex;
        },
        isDisabled: function(jobIndex) {
            if (jobIndex >= this.displayIndex &&
                jobIndex <= this.displayIndex + this.displayNum -1) {
                return false;
            }
            return true;
        },
        clickPrevBtn: function() {
            this.displayIndex --;
            if (this.isDisabled(this.activeJob)) {
                this.activeJob = this.displayIndex + this.displayNum - 1;
            }
        },
        clickNextBtn: function() {
            if (this.displayIndex < this.jobs.length - this.displayNum) {
                this.displayIndex ++;
            }
            if (this.isDisabled(this.activeJob)) {
                this.activeJob = this.displayIndex;
            }
        }
    },
    computed: {
        positionX: function() {
            let adjustment = 0;

            if (this.showButton) {
                if (this.displayNum == 1) {
                    adjustment = this.slideWidth / 2 +
                                 this.displayIndex * this.slideWidth + 20;
                    return `calc(50vw - ${adjustment}px)`;
                }

                adjustment = this.slidesOffsetBefore -
                             this.displayIndex * this.slideWidth
                return `${adjustment}px`;
            }
            else {
                adjustment = this.jobs.length / 2 * this.slideWidth;
                return `calc(50vw - ${adjustment}px)`;
            }
        },
        showButton: function() {
            return this.jobs.length > this.displayNum ? true : false;
        },
        prevBtnDisable: function() {
            return this.displayIndex == 0 ? true : false;
        },
        nextBtnDisable: function() {
            return this.displayIndex ==
                   (this.jobs.length - this.displayNum) ? true : false;
        }
    },
    mounted: function() {
        let winWidth = window.innerWidth;
        this.getDisplayNum();
        window.addEventListener("resize", this.getDisplayNum);
    }
}
</script>

<style scoped lang="scss">
@import "../static/styles/palette.scss";

.section {
  background-color: $blue;

  & .slider-wrapper {
    display: flex;
    position: relative;
    width: 100%;
    overflow-x: hidden;
    z-index: 10;

    & .sliders {
      display: flex;
      position: relative;
      min-width: 3000px;
      transition: transform 0.8s;
      transition-timing-function: ease-in-out;
    }

    & .button-prev {
      position: absolute;
      width: 0;
      height: 0;
      border-style: solid;
      border-width: 30px 30px 30px 0;
      border-color: transparent white transparent transparent;
      left: 100px;
      top: 40%;
      z-index: 15;
      cursor: pointer;
    }

    & .button-next {
      position: absolute;
      width: 0;
      height: 0;
      border-style: solid;
      border-width: 30px 0 30px 30px;
      border-color: transparent transparent transparent white;
      right: 100px;
      top: 40%;
      z-index: 15;
      cursor: pointer;
    }

    & .button-disabled {
      opacity: 0.3;
      cursor: auto;
      pointer-events: none;
    }
  }

  & .jobs-detail-container {
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
    margin-top: -35px;
    padding: 110px 0 90px;
    width: 100%;
    z-index: 0;
    background-color: $darkGray;
  }
}

@media all and (max-width: 768px) {
  .section {
    .jobs-detail-container {
      padding: 85px 0 50px;
    }
  }
}

@media all and (max-width: 640px) {
  .section {
    & .slider-wrapper {
      & .button-prev {
        left: 60px;
      }

      & .button-next {
        right: 60px;
      }
    }
  }
}

@media all and (max-width: 480px) {
  .section {
    .jobs-detail-container {
      padding: 70px 0 50px;
    }

    & .slider-wrapper {
      & .button-prev {
        left: 40px;
      }

      & .button-next {
        right: 40px;
      }
    }
  }
}

@media all and (max-width: 320px) {
  .section {
    .jobs-detail-container {
      padding: 70px 0 50px;
    }

    & .slider-wrapper {
      & .button-prev {
        left: 20px;
      }

      & .button-next {
        right: 20px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// SectionJob.vue?579b9e1f